import React from 'react';
import { Form } from '../../../ui/universe';
import { Input, Tooltip, Button } from 'tdesign-react';

/** 逐行占位文案，超过后使用兜底文案 */
const DEFAULT_PLACEHOLDERS = ['如：通过', '如：不通过', '如：人工判断'];
const FALLBACK_PLACEHOLDER = '填写其他判断结果';

/**
 * 枚举值集合渲染器
 * value 为字符串数组，按「序号 + 输入框 + 删除」逐行编辑，支持动态增删
 */
function EnumListRenderer({ params, value, disabled, onChange }) {
  const list = Array.isArray(value) ? value : [];
  // 空列表时保留一行占位，便于直接输入
  const rows = list.length ? list : [''];
  const maxCount = params.maxCount || 20;
  const itemMaxLength = params.itemMaxLength || 100;

  const updateAt = (index, val) => {
    const next = [...rows];
    next[index] = val;
    onChange && onChange(next);
  };

  const removeAt = (index) => {
    if (rows.length <= 1) return;
    onChange && onChange(rows.filter((_, i) => i !== index));
  };

  const addRow = () => {
    if (rows.length >= maxCount) return;
    onChange && onChange([...rows, '']);
  };

  const placeholderAt = (index) =>
    DEFAULT_PLACEHOLDERS[index] || FALLBACK_PLACEHOLDER;

  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div style={{ width: '100%' }}>
        {rows.map((item, index) => (
          <div
            key={index}
            style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
          >
            <span
              style={{ width: '24px', flex: 'none', color: '#00000073' }}
            >
              {index + 1}
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <Input
                value={item}
                maxlength={itemMaxLength}
                disabled={disabled}
                placeholder={placeholderAt(index)}
                onChange={(val) => updateAt(index, val)}
              />
            </div>
            <span
              onClick={() => !disabled && removeAt(index)}
              title="删除该枚举值"
              style={{
                marginLeft: '12px',
                flex: 'none',
                fontSize: '16px',
                color: disabled || rows.length <= 1 ? '#00000026' : '#00000073',
                cursor: disabled || rows.length <= 1 ? 'not-allowed' : 'pointer',
              }}
            >
              ×
            </span>
          </div>
        ))}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button
            theme="primary"
            variant="text"
            size="small"
            disabled={disabled || rows.length >= maxCount}
            onClick={addRow}
          >
            ＋ 添加枚举值
          </Button>
          <span style={{ fontSize: '12px', color: '#00000073' }}>
            最多 {maxCount} 个
          </span>
        </div>
      </div>
    </Form.Item>
  );
}

export default EnumListRenderer;
